module.exports = __webpack_public_path__ + "static/media/halo-clean.4227194f.svg";